import { render, staticRenderFns } from "./PaginationSize.vue?vue&type=template&id=78148498"
import script from "./PaginationSize.vue?vue&type=script&lang=js"
export * from "./PaginationSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports